<template>
  <div :class="{ 'd-inline-flex align-middle mr-2': !botaoDropdown }">
    <template v-if="tipoBotao === 'texto'">
      <button
        type="button"
        class="btn btn-sm btn-warning font-weight-bold"
        @click.prevent="abrir"
      >
        <i class="fas fa-cog"></i>Configuração
      </button>
    </template>
    <template v-else-if="tipoBotao == 'icone'">
      <b-button
        :variant="variant"
        size="sm"
        class="btn-icon"
        v-b-tooltip.noninteractive
        title="Configuração"
        @click.prevent="abrir"
      >
        <i class="fas fa-cog"></i>
      </b-button>
    </template>
    <template v-else-if="tipoBotao === 'dropdown'">
      <b-dropdown-item @click.prevent="abrir"
        ><i class="fas fa-cog mr-2"></i>Configuração</b-dropdown-item
      >
    </template>

    <b-modal
      ref="mdlConfiguracao"
      id="mdlConfiguracaoId"
      ok-title="Salvar"
      ok-variant="success"
      @ok="salvar"
      cancel-title="Cancelar"
      size="xl"
      scrollable
      ignore-enforce-focus-selector=".swal2-container, .p-dropdown-panel"
      no-close-on-esc
      no-close-on-backdrop
      content-class="config-modal-content"
      dialog-class="config-modal-dialog"
      body-class="px-0 pb-2 pt-0"
      header-class="config-modal-header border-0"
      footer-class="config-modal-footer"
    >
      <template #modal-title>
        Configuração
        <span v-if="rotuloConta" class="modal-conta-inline ml-2">
          <i class="fas fa-building mr-1"></i>{{ rotuloConta }}
        </span>
      </template>

      <b-tabs
        v-model="abaSelecionada"
        content-class="p-4"
        @activate-tab="verificarAlteracaoAba"
        lazy
        nav-wrapper-class="sticky-top bg-white"
        nav-class="config-tabs-nav"
      >
        <b-tab title="Geral" active v-if="checkSuperAdmin">
          <tab-configuracao
            :conta="conta"
            ref="abaConfiguracao"
            @aba-alterada="abaAlterada"
          ></tab-configuracao>
        </b-tab>

        <b-tab title="Plano" ref="abaPlano">
          <tab-plano
            :conta="conta"
            ref="abaPlano"
            @aba-alterada="abaAlterada"
          ></tab-plano
        ></b-tab>

        <b-tab title="Chat" ref="abaChat">
          <tab-chat
            :conta="conta"
            ref="abaChat"
            @aba-alterada="abaAlterada"
            @recursos-atualizados="recursosAtualizados"
          ></tab-chat>
        </b-tab>

        <b-tab title="Recursos" v-if="checkSuperAdmin"
          ><tab-recursos
            :conta="conta"
            ref="abaRecursos"
            @aba-alterada="abaAlterada"
            @recursos-atualizados="recursosAtualizados"
          ></tab-recursos
        ></b-tab>

        <b-tab title="Faturamento" v-if="checkSuperAdmin"
          ><tab-faturamento
            :conta="conta"
            :subconta="!exibirAbasConta"
            ref="abaFaturamento"
            @aba-alterada="abaAlterada"
            @salvando="salvandoAba = $event"
          ></tab-faturamento
        ></b-tab>

        <b-tab
          title="Email/SMTP"
          v-if="verificarRecursoAtivo('EMAIL') && checkSuperAdmin"
          ><tab-email
            :conta="conta"
            ref="abaEmail"
            @aba-alterada="abaAlterada"
          ></tab-email
        ></b-tab>

        <b-tab
          title="Atende"
          v-if="verificarRecursoAtivo('LIVE_CHAT') && checkSuperAdmin"
          ><tab-live-chat
            :conta="conta"
            ref="abaLivechat"
            @aba-alterada="abaAlterada"
          ></tab-live-chat
        ></b-tab>

        <b-tab
          title="Unidades"
          v-if="
            (verificarRecursoAtivo('BI') || verificarRecursoAtivo('DIZVC')) &&
            checkSuperAdmin
          "
          ><tab-unidades-nps
            :conta="conta"
            ref="abaUnidadesNps"
            @aba-alterada="abaAlterada"
          ></tab-unidades-nps
        ></b-tab>

        <b-tab
          title="CRM"
          v-if="verificarRecursoAtivo('CRM') && checkSuperAdmin"
        >
          <tab-crm
            :conta="conta"
            ref="abaCrm"
            @aba-alterada="abaAlterada"
          ></tab-crm>
        </b-tab>
      </b-tabs>

      <template #modal-footer="{ ok }">
        <button
          type="button"
          class="btn"
          :class="{
            'config-btn-secondary': !existeAlteracao,
            'btn-danger': existeAlteracao
          }"
          @click="cancelarAlteracao"
        >
          {{ !existeAlteracao ? "Fechar" : "Cancelar" }}
        </button>
        <button
          type="button"
          class="btn config-btn-primary"
          @click="ok()"
          :disabled="!existeAlteracao || salvandoAba"
        >
          {{ salvandoAba ? "Salvando..." : "Salvar" }}
        </button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ApiService from "@/core/services/api.service";
import Swal from "sweetalert2";

import Configuracao from "./Configuracao";
import Plano from "./Plano";
import Chat from "./Chat";
import Recursos from "./Recursos";
import Faturamento from "./Faturamento";
import Email from "./Email";
import Livechat from "./Livechat";
import UnidadesNps from "./UnidadesNps";
import Crm from "./Crm.vue";

export default {
  props: {
    conta: Object,
    variant: {
      type: String,
      default: "light-primary"
    },
    tipoBotao: {
      type: String,
      default: "icone"
    },
    exibirAbasConta: {
      type: Boolean,
      default: false
    }
  },

  components: {
    "tab-configuracao": Configuracao,
    "tab-plano": Plano,
    "tab-chat": Chat,
    "tab-recursos": Recursos,
    "tab-faturamento": Faturamento,
    "tab-email": Email,
    "tab-live-chat": Livechat,
    "tab-unidades-nps": UnidadesNps,
    "tab-crm": Crm
  },

  data() {
    return {
      abas: ["abaPlano", "abaChat"],
      abaSelecionada: 0,
      existeAlteracao: false,
      salvandoAba: false,
      recursos: []
    };
  },

  computed: {
    ...mapGetters(["checkSuperAdmin"]),
    botaoDropdown() {
      return this.tipoBotao === "dropdown";
    },

    // Rotulo da conta p/ faixa de identificacao no topo do modal, evitando
    // agir na conta errada quando aberto pela Central de Contas. Login e o
    // fallback principal pois nome as vezes vem vazio (con_nome_identificacao
    // e opcional no backend).
    rotuloConta() {
      const nome = (this.conta?.nome || this.conta?.conNome || "").trim();
      const login = (this.conta?.login || "").trim();

      if (nome && login) return `${nome} (@${login})`;
      if (login) return `@${login}`;
      return nome;
    }
  },

  methods: {
    montarAbas() {
      let abas = ["abaPlano", "abaChat"];

      if (this.checkSuperAdmin) {
        abas.unshift("abaConfiguracao");
        abas.push("abaRecursos");
        abas.push("abaFaturamento");
      }

      if (this.verificarRecursoAtivo("EMAIL")) {
        abas.push("abaEmail");
      }

      if (this.verificarRecursoAtivo("LIVE_CHAT")) {
        abas.push("abaLivechat");
      }

      if (this.verificarRecursoAtivo("QR_NPS")) {
        abas.push("abaUnidadesNps");
      }

      if (this.verificarRecursoAtivo("CRM")) {
        abas.push("abaCrm");
      }

      this.abas = abas;
    },

    async abrir(exibirModal = true) {
      const self = this;
      await ApiService.get(`conta/recurso-ativo/${this.conta.id}`).then(
        (response) => {
          const recursos = response.data.data;

          this.recursos = recursos.map(function (obj) {
            return obj.rec_codigo;
          });

          this.montarAbas();
        }
      );

      if (exibirModal) {
        this.$refs["mdlConfiguracao"].show();
      }
    },

    salvar(e) {
      e.preventDefault();

      if (this.salvandoAba) {
        return;
      }

      const aba = this.abas[this.abaSelecionada];
      this.$refs[aba].salvar();
    },

    verificarAlteracaoAba(currentTab, previousTab, e) {
      if (this.existeAlteracao) {
        e.preventDefault();

        Swal.fire({
          title: "Suas alterações não foram salvas!",
          text: "Existem alterações que ainda não foram salvas, ao continuar estas alterações serão descartadas! Deseja continuar?",
          showCancelButton: true,
          confirmButtonText: "Sim",
          cancelButtonText: "Não",
          customClass: {
            cancelButton: "btn btn-secondary",
            confirmButton: "btn btn-danger"
          },
          buttonsStyling: false
        }).then((result) => {
          if (result.isConfirmed) {
            this.existeAlteracao = false;

            this.abaSelecionada = currentTab;
          }
        });
      }
    },

    cancelarAlteracao(e) {
      if (this.existeAlteracao) {
        e.preventDefault();

        Swal.fire({
          title: "Suas alterações não foram salvas!",
          text: "Existem alterações que ainda não foram salvas, ao continuar estas alterações serão descartadas! Deseja cancelar e sair?",
          showCancelButton: true,
          confirmButtonText: "Sim",
          cancelButtonText: "Não",
          customClass: {
            cancelButton: "btn btn-secondary",
            confirmButton: "btn btn-danger"
          },
          buttonsStyling: false
        }).then((result) => {
          if (result.isConfirmed) {
            this.existeAlteracao = false;

            this.$refs["mdlConfiguracao"].hide();
          }
        });
      } else {
        this.$refs["mdlConfiguracao"].hide();
      }
    },

    abaAlterada(valor) {
      this.existeAlteracao = valor;
    },

    verificarRecursoAtivo(recurso) {
      return this.recursos.includes(recurso);
    },

    recursosAtualizados() {
      this.abrir(false);
    }
  }
};
</script>

<style lang="scss">
.config-modal-dialog {
  .config-modal-content {
    border: 1px solid #eeecf3;
    border-radius: 16px;
    box-shadow: 0 12px 40px rgba(31, 20, 60, 0.15);
    overflow: hidden;
  }
}

.config-modal-header {
  padding: 1.5rem 1.75rem 0.75rem;

  .modal-title {
    font-weight: 700;
    color: #2b2640;
  }

  .close {
    color: #2b2640;
    text-shadow: none;
    outline: none;

    &:hover {
      color: #472282;
    }
  }
}

.config-modal-footer {
  padding: 1rem 1.75rem 1.5rem;
  border-top: 1px solid #eeecf3;

  // Repinta os botões padrão do bootstrap-vue (ok-variant/cancel-title) para
  // quem usa footer-class="config-modal-footer" sem montar um #modal-footer
  // customizado — mesma paleta de .config-btn-primary/secondary.
  .btn-success {
    background-color: #472282;
    border-color: #472282;
    color: #fff;

    &:hover:not(:disabled) {
      background-color: #3a1b6b;
      border-color: #3a1b6b;
    }
  }

  .btn-secondary {
    background-color: #fff;
    border: 1px solid #d8d6e3;
    color: #472282;

    &:hover {
      background-color: #f4f2f9;
      border-color: #d8d6e3;
      color: #472282;
    }
  }
}

.config-tabs-nav {
  padding: 0 1.75rem;
  border-bottom: 1px solid #eeecf3;

  .nav-item {
    margin-right: 0.25rem;
  }

  .nav-link {
    border: 0;
    border-radius: 8px 8px 0 0;
    padding: 0.85rem 1.25rem;
    margin-bottom: -1px;
    color: #837f95;
    font-weight: 500;
    border-bottom: 3px solid transparent;
    transition: background-color 0.15s ease, color 0.15s ease;

    &:hover:not(.disabled) {
      background-color: #f4f2f9;
      color: #472282;
    }

    &.active {
      background-color: #ece8f2;
      color: #472282;
      border-bottom-color: #472282;
    }
  }
}

.config-btn-secondary {
  background-color: #fff;
  border: 1px solid #d8d6e3;
  color: #472282;

  &:hover {
    background-color: #f4f2f9;
    border-color: #d8d6e3;
    color: #472282;
  }
}

.config-btn-primary {
  background-color: #472282;
  border-color: #472282;
  color: #fff;

  &:hover:not(:disabled) {
    background-color: #3a1b6b;
    border-color: #3a1b6b;
    color: #fff;
  }

  &:disabled {
    opacity: 0.5;
  }
}

// Padrão de inputs "modernizados" (cantos arredondados, foco roxo),
// reaproveitado por qualquer formulário que use class="config-form".
.config-form {
  label {
    font-weight: 500;
    color: #464457;
    margin-bottom: 0.4rem;
  }

  .form-control,
  .custom-select {
    height: calc(1.5em + 1.3rem + 2px);
    padding: 0.65rem 1rem;
    border-radius: 8px;
    border: 1px solid #e2e0ea;

    &:focus {
      border-color: #472282;
      box-shadow: 0 0 0 0.1rem rgba(71, 34, 130, 0.15);
    }
  }
}
</style>

<style scoped lang="scss"></style>
